import { UseMutateFunction } from 'react-query';
import { QueriesTypes, usePostRequest } from '../../../common/hooks/queries';

export const useCreateFaturaMartinsLog = ({
    defaultErrorMessage,
    defaultSuccessMessage,
}: {
    defaultErrorMessage: string;
    defaultSuccessMessage: string;
}) : [
    UseMutateFunction<
    any, 
    unknown, 
    {
      requestPayload: {
        [key: string]: any; 
      };
      queryParams?:
        | {
            clientId?: string | number;
            step?: number;
          }
        | undefined;
    }
  >,
  boolean,
  boolean
] => {
    const { isLoading, isError, mutate } = usePostRequest(QueriesTypes.MartinsLogFaturas, {
    defaultErrorMessage,
    defaultSuccessMessage,
    cleanEmptyValues: true,
  });

  return [mutate, isLoading, isError];
};

export interface GenerateExcelResponse {
  statusCode: number;
  message: string;
  file?: Blob;
}

export async function fetchReportXlsx(
  token: string, 
  selectedUnidade: string, 
  url: string
): Promise<GenerateExcelResponse> {

  const requestHeaders: HeadersInit = new Headers();
  requestHeaders.append('Authorization', `Bearer ${token}`);
  requestHeaders.append('quickcomexTenant', selectedUnidade); 

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: requestHeaders,
    });

    if (response.ok) {
      return {
        statusCode: response.status,
        message: "Download Realizado",
        file: await response.blob() 
      };
    }

    return {
      statusCode: response.status,
      message: await response.text()
    };
  } catch (error: any) {
    return {
      statusCode: 500,
      message: error.message || "Erro de conexão ao gerar XLSX",
    };
  }
}

export const downloadXlsxFile = (blob: Blob, name: string) => {
  const fileBlob = new Blob([blob], { 
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
  });
  
  const url = window.URL.createObjectURL(fileBlob);
  const link = document.createElement('a');
  link.href = url;
  link.download = name;

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export interface GenerateFileResponse {
  statusCode: number;
  message: string;
  file?: Blob;
}

export async function fetchFlatFileTxt(
  token: string, 
  selectedUnidade: string, 
  url: string
): Promise<GenerateFileResponse> {
  const requestHeaders: HeadersInit = new Headers();
  requestHeaders.append('Authorization', `Bearer ${token}`);
  requestHeaders.append('quickcomexTenant', selectedUnidade); 

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: requestHeaders,
    });

    if (response.ok) {
      return {
        statusCode: response.status,
        message: "Download Realizado",
        file: await response.blob() 
      };
    }

    return {
      statusCode: response.status,
      message: await response.text()
    };
  } catch (error: any) {
    return {
      statusCode: 500,
      message: error.message || "Erro de conexão ao gerar o arquivo",
    };
  }
}

export const downloadFile = (blob: Blob, name: string) => {
  const url = window.URL.createObjectURL(blob);
  
  const link = document.createElement('a');
  link.href = url;
  link.download = name;

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};